import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'

/**
 * Returns list of setup guide steps
 * @method GET
 */
export const getSetupGuide = (): Promise<any> => {
  return callApi({
    method: 'GET',
    endpoint: FP_ENDPOINTS.setupGuide,
  })
}
